export function createObjectURL(fileOrBlob) {
  const urlCreator = window.URL || window.webkitURL;
  return urlCreator.createObjectURL(fileOrBlob);
}
